export class IgniteImageDef {
  imageUrl: string;
  title?: string;
  description?: string;
  width?: string;
  height?: string;
  expandable?: boolean;
}
